import React from "react";
import ReactDOM from "react-dom/client";

import { WPToastNotificationProvider } from "./packages/WPToastNotification";

import App from "./App";
import reportWebVitals from "./reportWebVitals";

import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/fonts.css";
import "./index.css";

import "./i18n";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <WPToastNotificationProvider>
    <App />
  </WPToastNotificationProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
